module.exports = {"name":"Damatrà","description":"","imgurl_logo":"","imgurl_cover":"","contact_name":"Roberto","phone":"+39 340 30 87 943","email":"info@damatrafolk.it","fbpageurl":"https://www.facebook.com/DamatraFolkBand","website":"","location":{"state":"it","city":"Monticello Brianza (MB)","address":""}}


//////////////////
// WEBPACK FOOTER
// ./src/data/groupinfo.json
// module id = 50
// module chunks = 0